var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',{staticClass:"secondhand-list-item"},[_c('td',{staticClass:"mac"},[_vm._v(_vm._s(_vm.secondhand.mac))]),_c('td',{staticClass:"start-date"},[_vm._v(_vm._s(_vm.secondhand.startDate))]),_c('td',{staticClass:"end-date"},[_vm._v(_vm._s(_vm.secondhand.endDate))])])
}
var staticRenderFns = []

export { render, staticRenderFns }